import MainContent from '../../components/mainContent/MainContent';
import { Outlet } from 'react-router-dom';
import { BuscarPacienteContent } from './components/BuscarPacienteContent';

export default function BuscarPaciente() {
  return (
    <>
      <MainContent
        titulo='Buscar Pacientes'
        component={<BuscarPacienteContent />}
        tableMaxWidth
      />
      <Outlet />
    </>
  );
}